module.exports = __webpack_public_path__ + "static/img/7.b9aaa72.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/20250903/szr/7.png
// module id = d57G
// module chunks = 0